import type { IconSvgObject } from './types';

const MusicNote02Icon: IconSvgObject = [
  ["path", { d: "M11 17.0002C11 19.2093 9.20914 21.0002 7 21.0002C4.79086 21.0002 3 19.2093 3 17.0002C3 14.791 4.79086 13.0002 7 13.0002C9.20914 13.0002 11 14.791 11 17.0002Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 17.0002V4.20711C11 3.76165 11.5613 3.51512 11.9214 3.77733C14.2856 5.49879 18.3852 6.87161 21 6C21 8.59967 19.8369 10.9899 17 11C14.8089 11.0078 12.4359 8.9359 11 7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MusicNote02Icon;
